import { ES_CO } from '@nubank/www-latam-commons/config';

import { getInterestRateFileUrl } from '../../utils/environmentUtils';

export function getMonthToUpperCase(month) {
  const dateMonth = month.toLocaleString(ES_CO, { month: 'long' });
  return dateMonth.charAt(0).toUpperCase() + dateMonth.slice(1);
}

export function generateInterestRateResponse(interestRateInfo) {
  const interestRateYear = interestRateInfo.end_date.split('-')[0];
  const interestRateStartDay = interestRateInfo.start_date.split('-')[2];
  const interestRateDate = new Date(interestRateInfo.end_date);
  const interestRateValue = String((parseFloat(interestRateInfo.rate) * 100)
    .toFixed(2));
  const interestRateMonth = getMonthToUpperCase(interestRateDate);

  return {
    rate_value: interestRateValue,
    month: interestRateMonth,
    year: interestRateYear,
    start_day: interestRateStartDay,
  };
}

export async function getInterestRate() {
  const interestRateURL = getInterestRateFileUrl();
  const interestResponse = await fetch(interestRateURL).then(response => response.json());
  return generateInterestRateResponse(interestResponse);
}
